import React from 'react'

const Header = () => {
    return ( 
        
        <div className="p-6 mt-5">
             <h1 id="titulo" className="text-4xl mt-5 text-white font-bold uppercase text-center">Busca el Clima</h1>
        <div id="resultado">
            <p className="text-center text-white mt-6">Agrega tu ciudad y país, el resultado se mostrará aquí</p>
                                         
        </div>
    </div>
     );
}
 
export default Header;